import React, { Fragment, useState } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Btn, H4, P, Image } from '../../../AbstractElements';
import { EmailAddress, EmailPassword, ForgotPassword, Password, RememberPassword, SignIn, signinaccount } from '../../../Constant';
import SocialAuth from './SocialAuth';
import { Link } from 'react-router-dom';


const LoginForm = () => {
  const [togglePassword, setTogglePassword] = useState(false);

  return (
    <Fragment>
      <div>
        <div className='logo'>
          <Image className='img-fluid for-light mx-auto' src={require('../../../assets/images/logo/login.png')} />
        </div>
        <div className='login-main'>
          <Form className='theme-form'>
            <H4 className='text-center'>{signinaccount}</H4>
            <P className='text-center'>{EmailPassword}</P>
            <FormGroup className='form-group'>
              <Label className='col-form-label'>{EmailAddress}</Label>
              <Input className='form-control' type='email' required placeholder='Test@gmail.com' />
            </FormGroup>
            <FormGroup className='form-group'>
              <Label className='col-form-label'>{Password}</Label>
              <div className='form-input position-relative'>
                <Input className='form-control' type={togglePassword ? 'text' : 'password'} placeholder='*********' required />
                <div className='show-hide' onClick={() => setTogglePassword(!togglePassword)}>
                  <span className={togglePassword ? '' : 'show'}></span>
                </div>
              </div>
            </FormGroup>
            <FormGroup className='form-group mb-0'>
              <div className='checkbox p-0'>
                <Input id='checkbox1' type='checkbox' />
                <Label className='text-muted' for='checkbox1'>
                  {RememberPassword}
                </Label>
              </div>
              <Link to={`${process.env.PUBLIC_URL}/auth/forget-password`} className='link'>
                {ForgotPassword}
              </Link>
              <div className='text-end mt-3'>
                <Btn color='primary w-100' className='btn-block'>
                  {SignIn}
                </Btn>
              </div>
            </FormGroup>
            <SocialAuth />
          </Form>
        </div>
      </div>
    </Fragment>
  );
};

export default LoginForm;
